import { render, staticRenderFns } from "./ui-info-right-block-tabby.vue?vue&type=template&id=341762e6&scoped=true&"
import script from "./ui-info-right-block-tabby.vue?vue&type=script&lang=js&"
export * from "./ui-info-right-block-tabby.vue?vue&type=script&lang=js&"
import style0 from "./ui-info-right-block-tabby.vue?vue&type=style&index=0&id=341762e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341762e6",
  null
  
)

export default component.exports